import { render, staticRenderFns } from "./TabelaMonitoramentoAgricola.vue?vue&type=template&id=4ee681c0&scoped=true&lang=pug"
import script from "./TabelaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./TabelaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./TabelaMonitoramentoAgricola.vue?vue&type=style&index=0&id=4ee681c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee681c0",
  null
  
)

export default component.exports